export const example = 'https://docker.geotalent.co.th/wfh-api-dev/api/lookup/reason'
export const login = `${process.env.REACT_APP_CU_IRB_API_URL}/auth/login` //'https://gdev.geotalent.co.th/VirtualRunAPI/api/lookup/employee'
export const test = `${process.env.REACT_APP_CU_IRB_API_URL}/xxxxxxxxxx`

export const getProfile = `${process.env.REACT_APP_CU_IRB_API_URL}/users/getProfile`
export const pdpa = `${process.env.REACT_APP_CU_IRB_API_URL}/users/pdpa/info`
